import styled from "styled-components";
import { Swiper } from "swiper/react";

export const LogoCarouselDiv = styled.div`
  width: 100%;
  height: 100px;
  position: relative;
`;

export const LogoCarouselSwiperWrapper = styled.div`
  width: 100vw;
  height: 80px;
  position: absolute;
  top: 10px;
  left: 0%;
  transform: translateX(-25%);

  @media (min-width: 767px) {
    left: 50%;
    transform: translateX(-50%);
    max-width: 1280px;
  }
`;

export const SwiperDiv = styled(Swiper)`
  width: 150vw;

  @media (min-width: 767px) {
    width: 100vw;
    max-width: 1280px;
  }
`;

export const LogoSlideWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  img {
    width: 100%;
    max-height: 40px;
    object-fit: contain;
    max-width: 160px;
  }
`;
